import { Group } from '@mantine/core';
import { useNavigate } from 'react-router';
import { useHasPermissions } from '../../helpers/auth-helpers/auth.hooks';
import { Permissions } from '../../helpers/auth-helpers/auth.type';
import { useFeatureFlag } from '../../helpers/feature-flags/feature-flags.hooks';
import { FeatureFlag } from '../../helpers/feature-flags/feature-flags.type';
import { baseWhite, secondaryBase } from '../../styles/design-tokens';
import { Button } from '../../ui-library/button/button';
import { Icon } from '../../ui-library/icon/icon';
import { getViewTypeTitle } from './process.helpers';
import { VALUE_TYPE_ICONS, ViewType } from './process.type';

export const ProcessTabs = ({
  viewType,
  setViewType,
}: {
  viewType: ViewType;
  setViewType: (viewType: ViewType) => void;
}) => {
  const navigate = useNavigate();
  const hasFinancialsAccess = useHasPermissions(Permissions.FinancialsRead);
  const isUnifiedProcessGraphEnabled = useFeatureFlag(FeatureFlag.UnifiedProcessGraph);
  const visibleViewTypes = hasFinancialsAccess
    ? Object.values(ViewType)
    : Object.values(ViewType).filter((value) => value !== ViewType.Cost);

  return (
    <Group gap="xs">
      {visibleViewTypes.map((value) => (
        <Button
          size="xs"
          radius="xl"
          key={value}
          variant={value === viewType ? 'secondary' : 'outline'}
          onClick={() => setViewType(value)}
          leftSection={
            <Icon name={VALUE_TYPE_ICONS[value]} color={value === viewType ? baseWhite : secondaryBase} size={16} />
          }
        >
          {getViewTypeTitle(value)}
        </Button>
      ))}
      {isUnifiedProcessGraphEnabled && (
        <Button
          size="xs"
          radius="xl"
          variant="outline"
          onClick={() => navigate('/application/process/unified')}
          leftSection={<Icon name="account_tree" color={secondaryBase} size={16} />}
          rightSection={<Icon name="open_in_new" color={secondaryBase} size={14} />}
        >
          Unified Graph
        </Button>
      )}
    </Group>
  );
};
